module.exports = __webpack_public_path__ + "img/A6.11f44291.png";